module.exports = __webpack_public_path__ + "static/media/settle@2x.e573ac5b.png";